import React, {useEffect, useReducer, useRef} from 'react';
import {connect} from "react-redux";
import {
  SIDEBAR_HIDDEN_BUTTONS,
  SIDEBAR_NAVIGATION_BUTTONS,
  SIDEBAR_TYPE_AREA_NAVIGATION_BUTTONS
} from "../../constants";
import {FormattedMessage} from "react-intl";
import $ from "jquery";
import {animateButtons, hideButtons} from "../SqftUiFunctions";
import {addChangeValuePopup, setSQFTActiveButton, setSQFTMenuOpened} from "../../../../actions/sqftMenuFunctions";
import EventManager from "../canvas/store/sqftEventManager";
import workspace from "../canvas/core/workspace";
import config from "../canvas/store/sqftConfig";
import FreeDraw from "../canvas/core/controls/freeDraw";
import {getIsSFTAreaGroup} from "../../helpers/sqftNavigationHelper";
import {getEdgeFeatureGroup, getEdgeFeatures} from "../../helpers/shapeHelper";
import AllFeaturesChecker from "../../../visComponents/allFeaturesChecker";
import WaterfallController from "../canvas/core/controls/WaterfallController";
import {handleMiteredClick, handleUnderlaymentClick} from "./NavigationHelper";
import {getCommonVisualizerType} from "../../../../config";

export const resetEvents = function () {
  EventManager.stealCursor(true);
  EventManager.resetCursor(self);
  workspace.setAllowEdges(false);
  workspace.setAllowBumpoutEdges(false);
};

const SqftNavigation = (props) => {
  // other popups, modals and so on
  const {activeButton, menuOpened, setSQFTActiveButton, setSQFTMenuOpened} = props;
  const buttonRefs = useRef({});
  const isSFTAreaGroup = getIsSFTAreaGroup();
  const edgeFeatureGroup = getEdgeFeatureGroup();
  let buttons = isSFTAreaGroup ? SIDEBAR_TYPE_AREA_NAVIGATION_BUTTONS : SIDEBAR_NAVIGATION_BUTTONS;
  const edgeNavItems = getEdgeFeatures(edgeFeatureGroup);

  const shouldSkipEdgeButton = edgeNavItems.length === 0;
    //edgeFeatureGroup === null
    //|| (edgeFeatureGroup && edgeFeatureGroup.part && !edgeFeatureGroup.part.allFeaturesReceived);

  if (shouldSkipEdgeButton) {
    buttons = Object.keys(buttons).reduce((newButtons, buttonKey) => {
      if (buttonKey !== SIDEBAR_NAVIGATION_BUTTONS.edge) {
        newButtons[buttonKey] = buttons[buttonKey];
      }
      return newButtons;
    }, {});
  }

  if (getCommonVisualizerType() === "fireplace") {
    buttons = Object.keys(buttons).reduce((newButtons, buttonKey) => {
      if (buttonKey !== SIDEBAR_HIDDEN_BUTTONS.toolWaterfall) {
        newButtons[buttonKey] = buttons[buttonKey];
      }
      return newButtons;
    }, {});
  }

  const [update, forceUpdate] = useReducer(x => x + 1, 0);

  const expanded = activeButton
    && menuOpened !== SIDEBAR_NAVIGATION_BUTTONS.bumpout
    && menuOpened !== SIDEBAR_HIDDEN_BUTTONS.toolWaterfall
    && menuOpened !== SIDEBAR_HIDDEN_BUTTONS.toolUnderlayment
    && menuOpened !== SIDEBAR_NAVIGATION_BUTTONS.mitered
    && (menuOpened === SIDEBAR_NAVIGATION_BUTTONS.move || Object.keys(buttons).some(buttonKey => menuOpened === buttonKey));

  useEffect(() => {
    const buttonEls = Object.values(buttonRefs.current);
    if (edgeFeatureGroup === null
      || (edgeFeatureGroup && edgeFeatureGroup.part && edgeFeatureGroup.part.allFeaturesReceived)
    ) {
      if (expanded) {
        animateButtons(buttonEls);
      } else {
        hideButtons(buttonEls);
      }
    }
  }, [expanded, update, edgeFeatureGroup]);

  const handleButtonClick = (buttonKey) => {
    setSQFTMenuOpened(buttonKey);
    setSQFTActiveButton(buttonKey);
    config.workspace.menuItemActive = buttonKey;
    resetEvents();
    switch (buttonKey) {
      case SIDEBAR_NAVIGATION_BUTTONS.move:
        setSQFTMenuOpened('');
        break;
      case SIDEBAR_NAVIGATION_BUTTONS.freeDraw:
        FreeDraw.init();
        break;
      case SIDEBAR_NAVIGATION_BUTTONS.resize:
        setSQFTMenuOpened('');
        setSQFTActiveButton(SIDEBAR_NAVIGATION_BUTTONS.resize);
        handleResizeClick();
        break;
      case SIDEBAR_NAVIGATION_BUTTONS.rotate:
        setSQFTMenuOpened('');
        setSQFTActiveButton(SIDEBAR_NAVIGATION_BUTTONS.rotate);
        handleRotateClick();
        break;
      case SIDEBAR_NAVIGATION_BUTTONS.angle:
        setSQFTMenuOpened('');
        handleAngleClick();
        break;
      case SIDEBAR_NAVIGATION_BUTTONS.text:
        setSQFTMenuOpened('');
        handleTextClick();
        break;
      case SIDEBAR_NAVIGATION_BUTTONS.label:
        setSQFTMenuOpened('');
        break;
      case SIDEBAR_NAVIGATION_BUTTONS.mitered:
        setSQFTMenuOpened(SIDEBAR_NAVIGATION_BUTTONS.mitered);
        handleMiteredClick();
        break;
      case SIDEBAR_NAVIGATION_BUTTONS.duplicate:
        setSQFTMenuOpened('');
        handleDuplicateClick()
        break;
      // case 'bumpout':
      //   handleBumpoutClick();
      //  break;
      case SIDEBAR_NAVIGATION_BUTTONS.toolWaterfall:
        handleWaterfallClick();
       break;
     case SIDEBAR_HIDDEN_BUTTONS.toolUnderlayment:
       setSQFTMenuOpened(SIDEBAR_HIDDEN_BUTTONS.toolUnderlayment);
       handleUnderlaymentClick();
       break;
      case 'reset':
        handleResetClick();
        break;

    }

    // if (buttonKey !== "resize") {
    //   workspace.setAllowEdges(false);
    // }
    //
    // if (buttonKey !== "bumpout") {
    //   workspace.setAllowBumpoutEdges(false);
    // }

    $('.lightbox-option-selected').removeClass('lightbox-option-selected');
  };

  const handleResizeClick = function () {
    EventManager.stealCursor(true);
    EventManager.resetCursor(self);
    workspace.setAllowEdges(true);
    workspace.setAllowLineHighlight(true);
    setTimeout(function () {
      workspace.setAllowLineHighlight(false)
    }, 1000)
  };

  const handleRotateClick = function () {
    //EventManager.stealCursor(true);
    //EventManager.setCursor("rotate-left", this, true);
    EventManager.stealCursor(true);
    config.workspace.menuItemActive = "rotate-left";
  };

  const handleDuplicateClick = function () {
    EventManager.stealCursor(true);
    EventManager.setCursor("duplicate", this, true);
    config.workspace.menuItemActive = "duplicate";
  };

  const handleAngleClick = function () {
    EventManager.stealCursor(true);
    EventManager.resetCursor(self);
    config.highlight.rotateAngle = true;
    workspace.getShapes().forEach((shape) => {
      if (Array.isArray(shape.rotateAngleParts) && shape.rotateAngleParts.length) {
        // todo fix bumpout rotation and remove this
        if (shape.isWithBumpout()) return;
        /////////////////////////////////////////
        shape.activateRotateAngle();
      }
    });
  };

  const handleTextClick = function () {
  };

  const handleResetClick = function () {
    EventManager.stealCursor(true);
    EventManager.resetCursor(self);
  };

  const handleWaterfallClick = function () {
    workspace.setAllowBumpoutEdges(true);
    workspace.setAllowLineHighlight(true);
    WaterfallController.addWaterfall_onClick();
    setTimeout(function () {
      workspace.setAllowLineHighlight(false)
    }, 1000)
  };

  return (
    <nav className={"navigation side" + (expanded ? " expanded" : "")} data-side="navigation">
      <div className="navigation-list">
        {edgeFeatureGroup && edgeFeatureGroup.part && !edgeFeatureGroup.part.allFeaturesReceived
          ? <AllFeaturesChecker subPart={edgeFeatureGroup} callBack={() => forceUpdate(1)} loaderOnly={true}/>
          : Object.keys(buttons).map((buttonKey) => (
            <button key={buttonKey}
                    ref={el => buttonRefs.current[buttonKey] = el}
                    className={"button button--" + buttonKey}
                    onClick={() => handleButtonClick(buttonKey)}>
              <span className="button-text">
                <FormattedMessage id={"sqft.navigation.submenu." + buttonKey}/>
              </span>
            </button>
        ))}
      </div>
    </nav>
  )
};

const mapStateToProps = (store) => ({
  menuOpened: store.sqftMenuState.menuOpened,
  activeButton: store.sqftMenuState.activeButton
});

const mapDispatchToProps = {
  setSQFTMenuOpened,
  setSQFTActiveButton,
  addChangeValuePopup,
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftNavigation);
